// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueCheckBoxList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Checkbox Container component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var constants = require('logic/data/Izenda.FilterDetailsConfigConstants');
  var ALL = constants.DEFAUFT_VALUE.ALL;
  var BLANK = constants.DEFAUFT_VALUE.BLANK;
  var NULL = constants.DEFAUFT_VALUE.NULL;
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  const { filter, identity, isEmpty, invokeArgs } = require('lodash/fp');
  var OperatorValueCheckBoxList = observer(
    React.createClass({
      propTypes: {
        onChange: React.PropTypes.func,
        filterSource: React.PropTypes.object.isRequired,
        filterInfo: React.PropTypes.object.isRequired,
        applyFormater: React.PropTypes.func
      },
      getDefaultProps: function() {
        return {
          applyFormater: identity
        };
      },

      // TODO: remove this block of code below when applying lazyload.
      // Try to get data (in subreport inherited filter) if filtersource is empty.
      componentDidMount: function() {
        isEmpty(this.props.filterSource) &&
          invokeArgs('getOperatorValueSource', [this.props.configField], this.props.store);
      },

      handleValueChange: function(item, data) {
        var selectedValues = isEmpty(this.props.filterInfo.value[0]) ? [] : this.props.filterInfo.value;
        var sourceValues = this.props.filterSource.map(function(item) {
          return item;
        });

        if (selectedValues.length === 1 && selectedValues[0] === ALL) {
          selectedValues = sourceValues;
          selectedValues.push(BLANK);
        }

        if (!item.checked) {
          selectedValues.push(item.value);
        } else {
          selectedValues = filter(function(i) {
            return i !== item.value;
          }, selectedValues);
        }

        // For check all
        if (item.value === ALL && !item.checked) {
          selectedValues = [ALL];
        } else if (item.value === ALL && item.checked) {
          selectedValues = [];
        } else if (item.value !== ALL && !item.checked && selectedValues.length === sourceValues.length + 1) {
          selectedValues = [ALL];
        }

        var onChange = this.props.onChange;
        onChange && onChange(selectedValues);
      },

      mapDataSource: function(source, filterValues, isCheckAll) {
        var applyFormater = this.props.applyFormater;
        return source.map(function(value) {
          var checked = isCheckAll ? true : filterValues.indexOf(value) > -1;
          return {
            value: value,
            label: applyFormater(value),
            checked: checked
          };
        });
      },

      render: function() {
        var source = [ALL, BLANK, NULL];
        var props = this.props;
        var filterSource = props.filterSource || [];
        var filterValues = props.filterInfo.value || [];

        // convert obser to normal array
        var filterSourceArray = filterSource.map(function(item) {
          return item;
        });

        // Add filter value
        source.push(...filterSourceArray);
        // Map filter source with filter value
        var data =
          filterValues.length === 1 && filterValues[0] === ALL
            ? this.mapDataSource(source, filterValues, true)
            : this.mapDataSource(source, filterValues, false);

        var options = data.map(
          function(item, index) {
            return (
              <div className="checkbox" key={'chk-' + index}>
                <label>
                  <input
                    type="checkbox"
                    value={item.value}
                    checked={item.checked ? true : false}
                    onChange={this.handleValueChange.bind(this, item, data)}
                    disabled={props.disabled}
                  />
                  <span title={item.label}> {item.label}</span>
                </label>
              </div>
            );
          }.bind(this)
        );

        return (
          <div className="filter-value">
            <ScrollBox autoHeight autoHeightMax={constants.MAX_HEIGHT}>
              {options}
            </ScrollBox>
          </div>
        );
      }
    })
  );

  module.exports = OperatorValueCheckBoxList;
})();



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueCheckBoxList.jsx